export const canTrack = (): boolean => {
  let canTrack = true
  const dntStatus =
    typeof navigator.doNotTrack === 'string'
      ? navigator.doNotTrack
      : typeof window.doNotTrack === 'string'
        ? window.doNotTrack
        : navigator.msDoNotTrack

  if (dntStatus === '1') {
    canTrack = false
  } else if (dntStatus === '0') {
    canTrack = true
  }

  return canTrack
}
